import { TimeDisplayFormat } from './time-display-format';
import { FontSizePreference } from './font-size-preference';

export interface IPresenterAccountPreferences {
    timeDisplayFormat: TimeDisplayFormat;
    fontSizePreference: FontSizePreference;
    warningColorAfterPercentElasped: number;
}


export class PresenterAccountPreferences implements IPresenterAccountPreferences {
    public timeDisplayFormat: TimeDisplayFormat = TimeDisplayFormat.ClientDefault;
    public fontSizePreference: FontSizePreference = FontSizePreference.Invalid;
    public warningColorAfterPercentElasped: number = 0;
}


